export enum EnvironmentType {
    dev = 'dev',
    local = 'local',
}
